import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  SvgIcon,
  SvgIconProps,
  SxProps,
  Theme,
  Typography,
} from '@mui/material'
import type { MouseEventHandler } from 'react'

import { Business } from '@mui/icons-material'
import {
  Highlighter,
  classes as highlighterClasses,
} from '@workwave-tidal/core/components/Highlighter'
import { LocationOn } from '@workwave-tidal/core/icons'

export type LocationEditorListItemProps = {
  asset: uui.domain.client.gps.SearchOnMapItem
  onClick: MouseEventHandler<HTMLLIElement>
  selected: boolean
  query: string
}

export function LocationEditorListItem(props: LocationEditorListItemProps) {
  const { asset, onClick, selected, query } = props

  return (
    <MenuItem
      onClick={onClick}
      selected={selected}
      data-asset-id={asset.id}
      data-testlabel={asset.type}
    >
      <ListItemIcon>
        <LocationEditorListItemIcon asset={asset} />
      </ListItemIcon>
      <ListItemText>
        <Typography noWrap sx={typographySx}>
          <Highlighter pattern={query} text={asset.address} sx={highlighterSx} />
        </Typography>
      </ListItemText>
    </MenuItem>
  )
}

const typographySx: SxProps<Theme> = {
  display: 'block',
}

const highlighterSx: SxProps<Theme> = {
  [`& .${highlighterClasses.highlight}`]: {
    background: 'transparent',
    fontWeight: 500,
  },
}

type LocationEditorListItemIconProps = Pick<LocationEditorListItemProps, 'asset'>

const depotIconSx: SxProps<Theme> = {
  scale: 0.9,
}

function LocationEditorListItemIcon(props: LocationEditorListItemIconProps) {
  switch (props.asset.type) {
    case 'depot':
      return <Depot sx={depotIconSx} />
    case 'address':
      return <LocationOn />
    case 'gpsPlace':
    case 'place':
      return <Business />
  }
}

/**
 * This Depot icon will use the SvgIcon as a base component, allowing to inherit the size based on the parent font size.
 * The Depot that come from `@/icons` will not do that, so it will be a fixed size.
 */
function Depot(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path d="M16.2072 4.15225C16.0839 4.06166 15.9161 4.06166 15.7928 4.15225L2.14277 14.1808C2.05301 14.2468 2 14.3515 2 14.4629V27.125C2 27.6082 2.39175 28 2.875 28H10.225C10.7083 28 11.1 27.6082 11.1 27.125V22.402C11.1 19.6959 13.2938 17.502 16 17.502C18.7062 17.502 20.9 19.6959 20.9 22.402V27.125C20.9 27.6082 21.2917 28 21.775 28H29.125C29.6082 28 30 27.6082 30 27.125V14.4629C30 14.3515 29.947 14.2468 29.8572 14.1808L16.2072 4.15225Z" />
    </SvgIcon>
  )
}
